import { useTranslation } from 'react-i18next';
import { useGetUserBalanceInfo } from 'src/hooks/useGetUserBalanceInfo';

export const Balance = () => {
  const { totalBalance } = useGetUserBalanceInfo();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col p-2.5 bg-as_header_bg rounded-[10px]">
      <p className="text-base font-bold text-as_balance_text">{t('blockActiveBonus.balance')}</p>
      <p className="font-bold text-xl text-as_balance_header">{totalBalance}</p>
    </div>
  );
};
